export const getEligiblePredictionCredits = (credits, organizations) => {
  const eligibleOrgIds = new Set(
    (organizations || [])
      .filter(
        (org) =>
          org?.stato === "attiva" && org?.tipo_istanza === "production"
      )
      .map((org) => org.objectId)
      .filter(Boolean)
  );

  return (credits || []).filter(
    (credit) => credit?.orgId && eligibleOrgIds.has(credit.orgId)
  );
};
